import { render, staticRenderFns } from "./ContractAlert.vue?vue&type=template&id=29456a24"
import script from "./ContractAlert.vue?vue&type=script&lang=js"
export * from "./ContractAlert.vue?vue&type=script&lang=js"
import style0 from "./ContractAlert.vue?vue&type=style&index=0&id=29456a24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports